import { usePlatformService } from 'core';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Container, Stack, Text, ThemeIcon, Title } from 'ui';
import { IconSecurityShield } from 'ui/Icons';

const EmailConfirmationPage = () => {
  const Platform = usePlatformService();
  const isMobile = Platform.mobileBrowser;

  const navigate = useNavigate();
  return (
    <Container size={514}>
      <Stack gap={48}>
        <Stack gap="lg">
          <ThemeIcon c="cobalt.3" variant="transparent" size={48}>
            <IconSecurityShield size={48} />
          </ThemeIcon>
          <Stack gap="xs">
            <Title fz="xxl">Email Confirmed</Title>
            <Text fz="sm" c="gray">
              Your email verifications is complete.
            </Text>
            <Text fz="sm" c="gray">
              You can now log in to your account and explore all the features.
            </Text>
          </Stack>
        </Stack>
        <ButtonMantine
          size="md"
          w={!isMobile ? 'fit-content' : '100%'}
          onClick={() => navigate('/home')}
        >
          Continue to Givebacks
        </ButtonMantine>
      </Stack>
    </Container>
  );
};

export { EmailConfirmationPage };
